import React from 'react';
import { useClassName } from 'common/hooks';
import PropTypes from 'prop-types';
import './venue-map.less';

const MAPPED_IN_MAP =
  'https://web.mappedin.com/dlv-labs/american-dream-guest.html#/profile';

const VenueMap = ({ locationId }) => {
  const className = useClassName('VenueMap');
  return (
    <div className={className('container')}>
      <div className={className('title')}>Where to find it</div>
      <iframe
        frameBorder={0}
        src={`${MAPPED_IN_MAP}?location=${locationId}`}></iframe>
    </div>
  );
};

VenueMap.propTypes = {
  locationId: PropTypes.string.isRequired,
};

export default VenueMap;
